export default {
	headers: {
		general: {
			patient: "Patient",
			options: "Options",
			attach: "Attacher",
			alert_history: "Histoire d'alerte",
			resume: "Résumé",
			readings: "Lectures",
			notifications: "Notifications",
			report: "Rapport",
			reports: "Rapports",
			attach_device: "Attacher un appareil",
			reading: "Lecture",
			position: "Position",
			zone: "Zone",
			pillbox: "Boîte à pilules",
			add_pill: "Ajouter Comprimé",
			appointment: "Rendez-vous",
			add_appointment: "Ajouter un rendez-vous",
			edit_pill: "Modifier Comprimé",
			healthreports: "Rapports de santé",
			medicaldocuments: "Documents médicaux",
			edit_configs: "Modifier les configurations",
			history: "Histoire",
			response: "Réponse",
			watch_profile: "Profil du patient",
			add_contact: "Ajouter le contact",
			disease: "Maladie",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/headers/headers_fr.js